import { TrackRoute } from '@portals/shared-frontend/components';

import { useEventFilterParams } from '@/hooks/useEventFilterParams';
import { ExplorerPage } from '@/pages/explorer/components/ExplorerPage';
import { EventFilter } from '@/pages/explorer/events/EventFilter';
import { PaginatedEvents } from '@/pages/explorer/events/PaginatedEvents';
import { FilterTags } from '@/pages/explorer/filters/FilterTags';

export default function EventExplorerPage() {
  const filterParams = useEventFilterParams();

  return (
    <div className="dark-mode">
      <ExplorerPage filterTags={<FilterTags {...filterParams} />} filters={<EventFilter />} title="Events Explorer">
        <TrackRoute name="Events Explorer" path="/explorer/events" type="events" />
        <PaginatedEvents />
      </ExplorerPage>
    </div>
  );
}
